import {
  Separator,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { InfoIcon } from 'lucide-react';
import type { SectionTitleProps } from './SectionTitle.types';

export function SectionTitle({ icon, title, tooltip }: SectionTitleProps) {
  return (
    <div>
      <Separator />
      <div className="my-6 flex items-center justify-between">
        <div className="flex flex-1 items-center gap-1">
          <span className="flex items-center text-muted-foreground">{icon}</span>
          <span className="text-body-lg font-medium text-foreground">{title}</span>
        </div>

        {tooltip && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <span aria-label={tooltip} className="flex items-center text-muted-foreground">
                  <InfoIcon className="size-5" />
                </span>
              </TooltipTrigger>
              <TooltipContent side="left">{tooltip}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
    </div>
  );
}
